export default (state = false, action) => {
    let { type, payload } = action
    switch (type) {
        case 'START_HUNT_PLANNER_MAP_LOADER':
            return true
        case 'STOP_HUNT_PLANNER_MAP_LOADER':
            return false
        case 'LOGOUT':
            return null
        default:
            return state
    }
}
